import { cn } from "@/lib/cn";
import type { CSSProperties } from "react";

type IconProps = {
  icon: string;
  className?: string;
  style?: CSSProperties;
};

const BASE_ICON_STYLES = "tw-font-normal tw-text-base tw-leading-none";

const Icon = ({ icon, className, style }: IconProps) => {
  if (icon?.startsWith("sd-")) {
    return (
      // biome-ignore lint/a11y/noSvgWithoutTitle: <no title needed>
      <svg
        className={cn("sd-remix tw-h-4 tw-w-4", className)}
        style={style}
        width="16"
        height="16"
      >
        <use xlinkHref={`/assets/custom.symbol.svg#${icon}`} />
      </svg>
    );
  }

  if (icon?.startsWith("ri-")) {
    return (
      <i className={cn(icon, BASE_ICON_STYLES, className)} style={style} />
    );
  }

  if (icon?.startsWith("fa-")) {
    return (
      <i
        className={cn(
          "fa-solid !tw-font-black",
          icon,
          BASE_ICON_STYLES,
          className,
        )}
        style={style}
      />
    );
  }

  return (
    <i
      className={cn("material-icons", BASE_ICON_STYLES, className)}
      style={style}
    >
      {icon}
    </i>
  );
};

export default Icon;
